import * as sonbp from "sonbp";
import * as ifbase from "../base";
import * as photoMani from "./photoMani";

// -----------------------------------------------
// アイテムの共通操作全般
// -----------------------------------------------

/**
 * 指定されたアイテムを選択状態にする
 */
export function selectItem(ifdto: ifbase.ifDto, item_type: string, idx: string) {

	let layer = ifbase.util.getActiveLayer(ifdto);

	var items = ifbase.util.getItems(layer.items, function (item: sonbp.object.baseItem): boolean {

		let vp = item.info.vendor_property.ffpsc;
		if (!vp || vp.item_type != item_type) return false;

		//今の処理モードで操作可能なタイプとidxか
		switch (ifdto.procMode) {
			case ifbase.constants.MODE_PHOTO_REGIST:
			case ifbase.constants.MODE_PHOTO_REPLACE:
			case ifbase.constants.MODE_PHOTO_MANI:
				if (item_type != ifbase.constants.ITYPE_PHOTO_BOX) return false;
				if (vp.idx != idx) return false;
				break;

			case ifbase.constants.MODE_SENDER_MANI:
				if (item_type != ifbase.constants.ITYPE_SENDER_TXT) return false;
				//差出人は１個のみ
				break;

			//case ifbase.constants.MODE_COMMENT_MANI:
			//	if (item_type != ifbase.constants.ITYPE_COMMENT_TXT) return false;
			//	if (vp.idx != idx) return false;
			//	break;

			case ifbase.constants.MODE_GREETING_MANI:
				if (item_type != ifbase.constants.ITYPE_GREETING_TXT) return false;
				if (vp.idx != idx) return false;
				break;

			case ifbase.constants.MODE_STAMP_MANI:
				if (item_type != ifbase.constants.ITYPE_STAMP_IMG) return false;
				if (vp.idx != idx) return false;
				break;

			case ifbase.constants.MODE_MYSTAMP_MANI:
				if (item_type != ifbase.constants.ITYPE_MYSTAMP_IMG) return false;
				if (vp.idx != idx) return false;
				break;

			case ifbase.constants.MODE_FONTGENIC_MANI:
				if (item_type != ifbase.constants.ITYPE_FONTGENIC_IMG) return false;
				if (vp.idx != idx) return false;
				break;

			default:
				return false;
		}

		return true;
	});

	if (items.length != 1) {
		throw new Error("現在の処理モードで操作可能なアイテムの中に、指定されたアイテムは存在しません。 item_type=" + item_type + ", idx=" + idx);
	}

	//アイテム選択
	let selector = ifdto.bpView.getListener()[0][0] as sonbp.listener.selector;
	selector.select(items[0].id);
}

/**
 * 配置済みアイテムのリストを返す
 */
export function getAllItems(ifdto: ifbase.ifDto, item_type: string[]): any[] {

	let result = [];

	for (let l = 0; l < ifdto.bpView._om._doc.pages[0].layers.length; l++) {
		let lay = ifdto.bpView._om._doc.pages[0].layers[l];

		let items = ifbase.util.getItems(lay.items, function (item: sonbp.object.baseItem): boolean {

			if (item_type.length > 0) {
				return item_type.some(val => val === item.info.vendor_property.ffpsc?.item_type);
			}
			else {
				return item.info.vendor_property.ffpsc?.item_type !== undefined;
			}
		});

		for (let i = 0; i < items.length; i++) {

			let item = items[i];
			let citem = (item.info.vendor_property.ffpsc.item_type == ifbase.constants.ITYPE_PHOTO_BOX) ? (<sonbp.object.groupItem>item).childs[0] : item;
			let posi = sonbp.tool.item.getPosition(ifdto.bpView, citem.id);

			let data = {
				id: item.id,
				item_type: item.info.vendor_property.ffpsc.item_type,
				idx: item.info.vendor_property.ffpsc.idx,
				file_id: citem.info.vendor_property.ffpsc?.file_id,
				x: posi.x,
				y: posi.y,
				w: posi.width,
				h: posi.height,
				r: (360 - posi.deg) % 360	//sonbpは左回転、業務は右回転
			};

			result.push(data);
		}
	}

	return result;
}

// -----------------------------------------------
// 画面ボタンでのアイテム操作用
// -----------------------------------------------

/**
 * アイテム移動
 * @summary 選択アイテムの移動操作を行います。
 */
export function move(ifdto: ifbase.ifDto, x: number, y: number): boolean {

	let v = ifdto.bpView;
	let editor = (<any>v.getListener()[2][0]);
	if (!editor) {
		throw new Error("Not found editor.");
	}
	let item = editor._select.items[0] as sonbp.object.baseItem;
	let isPhotoBox = ifbase.util.chkIsPhotobox(item);
	if (isPhotoBox) {
		item = (<sonbp.object.groupItem>item).childs[0];
	}
	let itemRefs = sonbp.util.obj.getItemRefById(v, [item.id]);
	var x = sonbp.util.bp.u2i(x, v._exp.docUnit, v._exp.userUnitValue);
	var y = sonbp.util.bp.u2i(y, v._exp.docUnit, v._exp.userUnitValue);

	// y軸変換
	y = (v._exp.basePoint == sonbp.constant.pointBase.LEFTTOP) ? -y : y;

	let dv = new sonbp.type.point(x, y);

	// 移動実施
	let result = v._om.itemChange(itemRefs, function (itemRefs) {

		for (var i = 0; i < itemRefs.length; i++) {

			const exec = () => {

				itemRefs[i].item.move(dv.x, dv.y);
			}

			if (!isPhotoBox) {

				exec();
				adjustPosition(ifdto, itemRefs[i].item, dv.x, dv.y);
			} else {

				const box = editor._select.items[0];
				const wakuPita = box.info.vendor_property.ffpsc?.waku_pita ?? true;
				if (!wakuPita) {
					const vitem = new sonbp.listener.editor.vitem(itemRefs[i].item);
					vitem.move(dv.x, dv.y);
					if (photoMani.chkIfImageExceedWaku(box, vitem))
						return false;
				}
				exec();
				photoMani.adjustPositionWaku(box, itemRefs[i].item);
			}
		}
		return true;
	});

	return result;
}

/**
 * アイテムスケール変更
 * @summary 指定アイテムのスケール変更を行います。
 */
export function scale(ifdto: ifbase.ifDto, sx: number, sy: number): boolean {

	let v = ifdto.bpView;
	let editor = (<any>v.getListener()[2][0]);
	if (!editor) {
		throw new Error("Not found editor.");
	}
	let item = editor._select.items[0] as sonbp.object.baseItem;
	let isPhotoBox = ifbase.util.chkIsPhotobox(item);
	if (isPhotoBox) {
		item = (<sonbp.object.groupItem>item).childs[0];
	}
	let itemRefs = sonbp.util.obj.getItemRefById(v, [item.id]);

	//拡縮制限チェック
	var ptIdx = 4;
	let s = {
		sx: sx,
		sy: sy
	};
	isPhotoBox ?
		photoMani.chkScaleOverWaku(ifdto, ifdto.bpClipImageEditor, item.matrix, item.getPlainPoints(), s) :
		chkScaleOver(ifdto, item, item.matrix, item.getPlainPoints(), s);
	sx = s.sx;
	sy = s.sy;

	let result = v._om.itemChange(itemRefs, function (itemRefs) {

		for (var i = 0; i < itemRefs.length; i++) {

			const exec = () => {

				let pts = itemRefs[i].item.points[ptIdx];
				itemRefs[i].item.scale(sx, sy);
				let pts2 = itemRefs[i].item.points[ptIdx];
				itemRefs[i].item.move(pts.x - pts2.x, pts.y - pts2.y);
			}

			if (!isPhotoBox) {

				exec();
				adjustPosition(ifdto, itemRefs[i].item);
			} else {

				const box = editor._select.items[0];
				const wakuPita = box.info.vendor_property.ffpsc?.waku_pita ?? true;
				if (!wakuPita) {
					const vitem = new sonbp.listener.editor.vitem(itemRefs[i].item);
					let pts = vitem.getPoints()[ptIdx];
					vitem.scale(sx, sy);
					let pts2 = vitem.getPoints()[ptIdx];
					vitem.move(pts.x - pts2.x, pts.y - pts2.y);
					if (photoMani.chkIfImageExceedWaku(box, vitem))
						return false;
				}
				exec();
				photoMani.adjustPositionWaku(box, itemRefs[i].item);
			}
		}
		return true;
	});

	return result;
}

/**
 * アイテム角度変更
 * @summary 指定アイテムに回転角度を与えます。画像枠のdeg=0,90,180,360度指定は外接フィットします。
 * @param deg 回転角度（-360～360）
 */
export function rotate(ifdto: ifbase.ifDto, deg: number, relativeId: string = ""): boolean {

	let v = ifdto.bpView;
	let editor = (<any>v.getListener()[2][0]);
	if (!editor) {
		throw new Error("Not found editor.");
	}
	let item = editor._select.items[0] as sonbp.object.baseItem;
	let wakuPita = item.info.vendor_property.ffpsc?.waku_pita ?? true;
	let isPhotoBox = ifbase.util.chkIsPhotobox(item);
	if (isPhotoBox) {
		item = (<sonbp.object.groupItem>item).childs[0];
	}
	let itemRefs = sonbp.util.obj.getItemRefById(v, [item.id]);

	let result = false;

	if (isPhotoBox && deg % 90 === 0 && wakuPita) {

		//回転＆外接フィット
		result = v._om.itemChange(itemRefs, (itemRefs) => {
			photoMani.photoFit(editor._select.items[0], item, deg, false, function (item) { });
			return true;
		});
	}
	else {

		result = v._om.itemChange(itemRefs, (itemRefs) => {
			for (var i = 0; i < itemRefs.length; i++) {

				if (!isPhotoBox) {

					deg = (deg % 90 === 0) ? deg - ((item.deg % 360) % 90) : deg;
					itemRefs[i].item.rotate(deg);
					adjustPosition(ifdto, itemRefs[i].item);
				} else {

					const box = editor._select.items[0];
					const wakuPita = box.info.vendor_property.ffpsc?.waku_pita ?? true;
					if (deg % 90 === 0) {
						deg = photoMani.chkRotate90(box, itemRefs[i].item.deg, deg);
					}
					if (!wakuPita) {
						const vitem = new sonbp.listener.editor.vitem(itemRefs[i].item);
						vitem.rotate(sonbp.util.c2d.rad(deg));
						if (photoMani.chkIfImageExceedWaku(box, vitem))
							return false;
					}
					itemRefs[i].item.rotate(deg);
					photoMani.adjustPositionWaku(box, itemRefs[i].item);
				}
			};
			return true;
		});
	}

	return result;
}

// -----------------------------------------------
// 移動制限ルール（画像枠以外）
// -----------------------------------------------

/**
 * はみ出しチェック
 * @summary ページをはみ出してはいけない。
 */
export function adjustPosition(ifdto: ifbase.ifDto, item: sonbp.object.baseItem, dx: number = 0, dy: number = 0): void {

	let vw = ifdto.bpView;

	//閾値
	let area = vw._om._doc.pages[0].size.mediaBoxRect;
	if (ifdto.txtRangeStamp && ifbase.util.chkIsStamp(item)) {

		// スタンプの場合
		let width = (area.width < area.height) ? ifdto.txtRangeStamp.w : ifdto.txtRangeStamp.h;
		let height = (area.width < area.height) ? ifdto.txtRangeStamp.h : ifdto.txtRangeStamp.w;
		let left = area.x1 + ((area.width - width) / 2);
		let bottom = area.y1 + ((area.height - height) / 2);
		area = new sonbp.type.rectPoint(
			left,
			bottom,
			left + width,
			bottom + height
		);

	}  else if (ifdto.txtRange) {

		// その他の場合
		let width = (area.width < area.height) ? ifdto.txtRange.w : ifdto.txtRange.h;
		let height = (area.width < area.height) ? ifdto.txtRange.h : ifdto.txtRange.w;
		let left = area.x1 + ((area.width - width) / 2);
		let bottom = area.y1 + ((area.height - height) / 2);
		area = new sonbp.type.rectPoint(
			left,
			bottom,
			left + width,
			bottom + height
		);
	}

	//サイズ調整
	let sx = 1;
	let sy = 1;
	let rect = item.rect;

	if (area.width < rect.width) {
		sx = area.width / rect.width;
	}
	if (area.height < rect.height) {
		sy = area.height / rect.height;
	}
	let sc = Math.min(sx, sy);

	if (sc !== 1) {
		console.debug("adjust scale.", "sc", sc);
		let pts = item.points;
		item.scale(sc, sc);
		let pts2 = item.points;
		item.move(pts[4].x - pts2[4].x, pts[4].y - pts2[4].y);
	}

	//位置調整
	let mx = 0;
	let my = 0;
	rect = item.rect;

	if (area.x2 < rect.x2) {
		mx = area.x2 - rect.x2;
	}
	if (area.x1 > rect.x1) {
		mx = area.x1 - rect.x1;
	}
	if (area.y2 < rect.y2) {
		my = area.y2 - rect.y2;
	}
	if (area.y1 > rect.y1) {
		my = area.y1 - rect.y1;
	}

	if (mx !== 0 || my !== 0) {
		console.debug("adjust move.", "x", mx, "y", my);
		item.move(mx, my);
	}
}

/**
 * 拡縮制限チェック
 * @summary 規定倍率の範囲内でなくてはいけない。
 */
export function chkScaleOver(ifdto: ifbase.ifDto, item: sonbp.object.baseItem, aMatrix: number[], aPoints: sonbp.type.point[], s: { sx: number, sy: number }): void {

	let vw = ifdto.bpView;

	//閾値
	let area = vw._om._doc.pages[0].size.mediaBoxRect;
	if (ifdto.txtRangeStamp && ifbase.util.chkIsStamp(item)) {

		// スタンプの場合
		let width = (area.width < area.height) ? ifdto.txtRangeStamp.w : ifdto.txtRangeStamp.h;
		let height = (area.width < area.height) ? ifdto.txtRangeStamp.h : ifdto.txtRangeStamp.w;
		let left = area.x1 + ((area.width - width) / 2);
		let bottom = area.y1 + ((area.height - height) / 2);
		area = new sonbp.type.rectPoint(
			left,
			bottom,
			left + width,
			bottom + height
		);

	} else if (ifdto.txtRange) {

		// その他の場合
		let width = (area.width < area.height) ? ifdto.txtRange.w : ifdto.txtRange.h;
		let height = (area.width < area.height) ? ifdto.txtRange.h : ifdto.txtRange.w;
		let left = area.x1 + ((area.width - width) / 2);
		let bottom = area.y1 + ((area.height - height) / 2);
		area = new sonbp.type.rectPoint(
			left,
			bottom,
			left + width,
			bottom + height
		);
	}
	let max = ifbase.util.chkIsStamp(item) ? ifbase.constants.STAMP_SCALE_MAX : 0;
	let min = ifbase.util.chkIsStamp(item) ? ifbase.constants.STAMP_SCALE_MIN : ifbase.constants.TEXT_SCALE_MIN;

	//等倍サイズ
	let or = item.info.vendor_property.ffpsc?.org_rect;
	if (or === undefined) {
		throw new Error("org_rect undefined. vp=" + item.info.vendor_property.ffpsc);
	}
	let orgRect = new sonbp.type.rectPoint(or[0], or[1], or[2], or[3]);
	//let orgPoints = sonbp.util.c2d.getPoints(orgRect);

	//n1 今の座標
	//init
	let pts = sonbp.util.c2d.setPointsMatrix(aPoints, aMatrix);
	let n1rect = sonbp.util.c2d.getRectOfPoints(pts);

	//console.debug("scale1", "n1rect", n1rect);

	//n2 拡大後
	//scale
	let n2matrix = sonbp.util.c2d.matrixScale(aMatrix, s.sx, s.sy);
	let n2points = sonbp.util.c2d.setPointsMatrix(aPoints, n2matrix);
	let n2rect = sonbp.util.c2d.getRectOfPoints(n2points);

	//閾値内に抑える
	let rad = sonbp.util.c2d.getRadian(pts[4], pts[5]);
	//let deg = sonbp.util.c2d.deg(rad);
	let orgRadmatrix = [Math.cos(rad), Math.sin(rad), -Math.sin(rad), Math.cos(rad), 0, 0];
	let orgRadrect = sonbp.util.c2d.getRect(orgRect, orgRadmatrix);
	if (max != 0) {

		let maxRect = sonbp.util.c2d.getRect(orgRadrect, [max, 0, 0, max, 0, 0]);
		if (maxRect.width < n2rect.width || maxRect.height < n2rect.height) {

			s.sx = s.sy = Math.min(maxRect.width / n1rect.width, maxRect.height / n1rect.height);
		}

	}
	{
		let minRect = sonbp.util.c2d.getRect(orgRadrect, [min, 0, 0, min, 0, 0]);
		if (s.sx < 0 || s.sy < 0 || minRect.width > n2rect.width || minRect.height > n2rect.height) {

			s.sx = s.sy = Math.max(minRect.width / n1rect.width, minRect.height / n1rect.height);
		}
	}

	console.debug("s", s.sx, "sm", n1rect.width * s.sx / orgRadrect.width);
}
